



































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import _ from "lodash";

import AppHeader from "./AppHeader.vue";
import ProjectHeader from "./ProjectHeader.vue";
import ProjectSidebar from "./ProjectSidebar.vue";
import { Project } from "@/api/project-api";
import ProjectMember from "@/entities/project-member";
import ProjectMemberModal from "./ProjectMemberModal.vue";
import { IconProps } from "../components/VIcon.vue";
import { isNewProject } from "@/preferences";
import ProjectBreadCrumbs from "@/components/project/ProjectBreadCrumbs.vue";
import EstimateSummary from "@/ui/order/components/EstimateSummary.vue";

@Component({
  components: {
    EstimateSummary,
    ProjectBreadCrumbs,
    AppHeader,
    ProjectHeader,
    ProjectSidebar,
    ProjectMemberModal
  }
})
export default class ProjectPage extends Vue {
  @Prop({ required: true }) projectId!: string;

  modalShow = false;
  projectStatus: any = null;
  pathNameOrderManagement: string[] = [
    "order-estimates",
    "order-invoice",
    "order-purchase"
  ];

  showMembers() {
    (this.$refs.memberModal as any).show();
  }

  async created() {
    await this.changeCurrentProject();
    this.initProjectStatus();
    this.initEstimateExpenseSummary();
  }

  beforeDestroy() {
    this.$store.dispatch("leaveProject");
    // 前の情報が残るので初期化する
    this.$store.commit("member/load-managers", []);
    this.$store.commit("member/load-workers", []);
  }

  @Watch("projectId")
  async changeCurrentProject() {
    await this.$store.dispatch("changeCurrentProject", this.projectId);
    await this.$store.dispatch("member/load-all", Number(this.projectId));
  }

  @Watch("project", { deep: true })
  initProjectStatus() {
    if (this.project) {
      this.projectStatus = {
        id: this.project.projectId,
        breadCrumb: this.project.breadCrumb
      };
    }
  }

  @Watch("project.projectId")
  initEstimateExpenseSummary() {
    if (this.project !== null && isNewProject(this.project.created)) {
      this.$store.dispatch("setProjectEstimateExpenseSummary");
    }
  }

  get project(): Project | null {
    return this.$store.state.project;
  }

  get projects(): Project[] {
    return _.orderBy(this.$store.state.assignedProjects, "created", "desc");
  }

  get memberIcons(): IconProps[] {
    return this.members.slice(0, 3).map(m => ({
      key: String(m.id),
      src: m.icon,
      alt: m.name,
      title: m.name
    }));
  }

  /* Store */

  private get members(): ProjectMember[] {
    return this.$store.getters["member/all"];
  }

  get estimateSummary() {
    return this.$store.state.project.estimateExpenseSummary;
  }

  get displayBreadCrumbAndSummary(): boolean {
    return (
      this.project !== null &&
      isNewProject(this.project.created) &&
      this.pathNameOrderManagement.includes(String(this.$route.name))
    );
  }
}
